import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // بدل userType فقط
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true); // للتحقق من التخزين قبل الرندر

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user"); // تخزين كامل المستخدم

    if (token && storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuth(true);
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", token);
    setUser(userData);
    setIsAuth(true);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    setIsAuth(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuth,
        user,
        userType: user?.type,
        login,
        logout,
        loading, // يمكن استخدامه في ProtectedRoute
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
